export default "__VITE_ASSET__2e023378__"